const angular = require('angular');
const app = angular.module('learn-directives');

app.directive('adminOverviewCharts', [
  'Application', 'Authorization',
  function (
    Application, Authorization,
  ) {
    return {
      restrict: 'E',
      replace: false,
      scope: {},
      template: require('../../templates/directives/admin-overview-charts.html'),
      controllerAs: 'adminOverviewCharts',
      controller: [
        '$scope',
        function ($scope) {
          var self = this;
          self.reportBaseUrl = Application.REPORTS;
          self.authToken = Authorization.getAuthToken();
          self.countryLocale = Application.dateFormatting.getOption();
        }
      ]
    };
  }
]);
